import Dashboard from '../Dashboard'
import DashboardView from '../Views/DashboardView'
import DashboardStudent from '../Views/DashboardStudent'
import AccessDenied from '@/components/AccessDenied/AccessDenied'
import AccessBlocked from '@/components/AccessBlocked/AccessBlocked'
import ModuleInactive from '@/components/ModuleInactive/ModuleInactive'

const DashboardRoute =
{
    path: '',
    meta: {
        name: {
            en: 'Index',
            es: 'Inicio'
        }
    },
    component: Dashboard,
    children: [
        {
            path: '/',
            component: DashboardView,
            meta: { name: 'Home' }
        }, {
            path: '/dashboard',
            component: DashboardStudent,
            name: 'DashboardStudent',
            meta: { name: 'Index' }
        }, {
            path: '/access-denied',
            component: AccessDenied,
            meta: { name: 'Access denied' }
        },{
            path: '/module-inactive',
            component: ModuleInactive,
            meta: { name: 'Module inactive' }
        },{
            path: '/access-blocked',
            component: AccessBlocked,
            meta: { name: 'Access blocked' }
        },
    ]
};

export default DashboardRoute
